"use strict";

var _slicedToArray = require("/codebuild/output/src355747095/src/gravitywell-website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollPosition = void 0;

var React = __importStar(require("react")); // Initial scroll position


var initialScrollPosition = {
  x: undefined,
  y: undefined
};
/**
 * Scroll position hook
 */

var useScrollPosition = function useScrollPosition(element) {
  var isClient = typeof window === "object";
  var target = React.useMemo(function () {
    return isClient ? element && element.current ? element.current : document.body : null;
  }, [element, isClient]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      initialised = _React$useState2[0],
      setInitialised = _React$useState2[1];

  var _React$useState3 = React.useState(initialScrollPosition),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      scrollPosition = _React$useState4[0],
      setScrollPostion = _React$useState4[1];
  /**
   * Updates the scroll position when called
   */


  var updateScrollPosition = React.useCallback(function () {
    var position = target === null || target === void 0 ? void 0 : target.getBoundingClientRect(); // If position exists

    if (position) {
      var x = position.left < 0 ? Math.abs(position.left) : -Math.abs(position.left);
      var y = position.top < 0 ? Math.abs(position.top) : -Math.abs(position.top);
      setScrollPostion({
        x: x,
        y: y
      });
    }
  }, [target]); //

  React.useEffect(function () {
    // If window client exists and the scroll position have not been initialised,
    // set them and update state.
    if (isClient && !initialised) {
      // Update the initialised state
      setInitialised(true); // Initialise the scroll position

      updateScrollPosition(); // Add "resize" event listener

      window.addEventListener("scroll", updateScrollPosition);
    } // On unmount, remove the "resize" event listener


    return function () {
      // If window client exists and the dimensions have been initialised
      if (isClient && initialised) {
        window.removeEventListener("scroll", updateScrollPosition);
      }
    };
  }, [initialised, isClient, target, updateScrollPosition]);
  return scrollPosition;
};

exports.useScrollPosition = useScrollPosition;